import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FCM } from '@ionic-native/fcm';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ProdutoListPage } from '../pages/produto-list/produto-list';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { InAppBrowser } from '@ionic-native/in-app-browser';


import { MoedaPipe } from "../pipes/moeda/moeda";
import { ProdutoViewPage } from '../pages/produto-view/produto-view';
import { PedidoListPage } from '../pages/pedido-list/pedido-list';
import { SemovelProvider } from '../providers/semovel/semovel';
import { HttpClientModule } from '@angular/common/http';
import { PedidoFormPage } from '../pages/pedido-form/pedido-form';
import { BuscaProdutoPage } from '../pages/busca-produto/busca-produto';
import { DataPipe } from '../pipes/data/data';
import { PromocoesListPage } from '../pages/promocoes-list/promocoes-list';
import { ReceitaListPage } from '../pages/receita-list/receita-list';
import { ReceitaViewPage } from '../pages/receita-view/receita-view';
import { VideoListPage } from '../pages/video-list/video-list';
import { CarrinhoProvider } from '../providers/carrinho/carrinho';
import { BotaoCarrinhoComponent } from '../components/botao-carrinho/botao-carrinho';
import { ViewProvider } from '../providers/view/view';
import { LoginPage } from '../pages/login/login';
import { RegistroPage } from '../pages/registro/registro';
import { DadosProvider } from '../providers/dados/dados';
import { PromocaoUtilProvider } from '../providers/promocao-util/promocao-util';
import { EnderecoPage } from '../pages/endereco/endereco';
import { AcessoexternoProvider } from '../providers/acessoexterno/acessoexterno';
import { BotaoBarraComponent } from '../components/botao-barra/botao-barra';
import { PagamentoPedidoFormPage } from '../pages/pagamento-pedido-form/pagamento-pedido-form';

import { IonicStorageModule } from '@ionic/storage';
import { MeusDadosPage } from '../pages/meus-dados/meus-dados';
import { PedidoViewPage } from '../pages/pedido-view/pedido-view';
import { InstitucionalPage } from '../pages/institucional/institucional';
import { SenhaPage } from '../pages/senha/senha';
import { MensagemListPage } from '../pages/mensagem-list/mensagem-list';
import { ConversaNutriListPage } from '../pages/conversa-nutri-list/conversa-nutri-list';
import { ConversaNutriPage } from '../pages/conversa-nutri/conversa-nutri';
import { ConversaProvider } from '../providers/conversa/conversa';
import { EnderecoListPage } from '../pages/endereco-list/endereco-list';
import { HomeCardProdutoComponent } from '../components/home-card-produto/home-card-produto';
import { LinhaTempoComponent } from '../components/linha-tempo/linha-tempo';
import { ContatoPage } from '../pages/contato/contato';

@NgModule({
  declarations: [
    MyApp,
    BotaoCarrinhoComponent,
    BotaoBarraComponent,
    LinhaTempoComponent,
    MoedaPipe,
    DataPipe,
    HomePage,
    ProdutoListPage,
    ProdutoViewPage,
    PedidoListPage,
    PedidoFormPage,
    BuscaProdutoPage,
    PromocoesListPage,
    ReceitaListPage,
    ReceitaViewPage,
    VideoListPage,
    LoginPage,
    RegistroPage,
    EnderecoPage,
    PagamentoPedidoFormPage,
    MeusDadosPage,
    PedidoViewPage,
    InstitucionalPage,
    SenhaPage,
    MensagemListPage,
    ConversaNutriListPage,
    ConversaNutriPage,
    EnderecoListPage,
    HomeCardProdutoComponent,
    ContatoPage,
  ], 
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp,{
      backButtonText: ''
    }),
    HttpClientModule,
    IonicStorageModule.forRoot({
      name: '__nutrimar',
         driverOrder: ['indexeddb', 'sqlite', 'websql']
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    BotaoCarrinhoComponent, 
    BotaoBarraComponent, 
    LinhaTempoComponent,
    HomePage,
    ProdutoListPage,
    ProdutoViewPage,
    PedidoListPage,
    PedidoFormPage,
    BuscaProdutoPage,
    PromocoesListPage,
    ReceitaListPage,
    ReceitaViewPage,
    VideoListPage,
    LoginPage,
    RegistroPage,
    EnderecoPage,
    PagamentoPedidoFormPage,
    MeusDadosPage,
    PedidoViewPage,
    InstitucionalPage,
    SenhaPage,
    MensagemListPage,
    ConversaNutriListPage,
    ConversaNutriPage,
    EnderecoListPage,
    HomeCardProdutoComponent,
    ContatoPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    SemovelProvider,
    FCM,
    InAppBrowser,
    CarrinhoProvider,
    ViewProvider,
    DadosProvider,
    PromocaoUtilProvider,
    AcessoexternoProvider,
    ConversaProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts